<template>
  <header id="header">
    <global-header></global-header>

    <div class="main-visual-wrap">
      <div class="main-visual" ref="mainImage">
        <picture>
          <source
            media="(min-width: 768px)"
            srcset="../assets/images/img_main.png"
          >
          <source
            media="(min-width: 320px)"
            srcset="../assets/images/img_main@sp.png"
          >
          <img class="mainVisual" src="../assets/images/img_main@sp.png" alt="東村アキコメインビジュアル">
        </picture>
      </div>
      <div data-aos="flip-left" data-aos-delay="500" class="main001">
        <img src="../assets/images/img_main001.svg" alt="">
      </div>
      <h1 data-aos="zoom-out-up" data-aos-delay="1000" class="main002">
        <img src="../assets/images/img_main002.png" alt="東村アキコのみそ鍋革命">
      </h1>
      <div data-aos="fade-left" data-aos-delay="1500" class="main003">
        <img src="../assets/images/img_main003.png" alt="">
      </div>
      <div data-aos="fade-right" data-aos-delay="1300" class="main004">
        <img src="../assets/images/img_main004.png" alt="">
      </div>
      <div data-aos="zoom-in-up" data-aos-delay="1900" class="main005">
        <img src="../assets/images/img_main005.svg" alt="">
      </div>
    </div>
  </header>
</template>

<script>
import AOS from 'aos'
import GlobalHeader from './GlobalHeader'

export default {
  name: 'mainVisual',

  components: {
    GlobalHeader
  },

  mounted () {
    this.AnimationStart()
  },

  methods: {
    AnimationStart () {
      window.onload = () => {
        this.$refs.mainImage.classList.add('loaded')
        this.Animation()
      }
    },

    Animation () {
      const aos = AOS.init({
        once: true
      })
      return aos
    }
  }
}
</script>

<style src="aos/dist/aos.css"></style>
<style lang="scss" scoped>
  @import "../assets/scss/common";

  .main-visual-wrap {
    position: relative;
    overflow-x: hidden;
  }

  .main-visual {
    opacity: 0;
    transition: all 200ms ease;

    img {
      width: 100%;
    }
  }

  .loaded {
    opacity: 1;
  }

  .main001 {
    position: absolute;
    left: 20px;
    top: 20px;

    img {
      width: 42.5vw;
    }
  }

  .main002 {
    position: absolute;
    bottom: 10.5%;
    width: 100%;
    z-index: 100;
    text-align: center;

    img {
      width: 57vw;
    }
  }

  .main003 {
    position: absolute;
    right: 0;
    bottom: 0;

    img {
      width: 28vw;
    }
  }

  .main004 {
    position: absolute;
    left: 0;
    bottom: 0;

    img {
      width: 44vw;
    }
  }

  .main005 {
    position: absolute;
    right: 2vw;
    top: 40px;

    img {
      width: 30vw;
    }
  }

  .txtCatch {
    position: absolute;
    left: 0;
    top: -2.3%;
    opacity: 0;
    width: 42.7%;
    max-width: 614px;
  }

  .txtRight {
    position: absolute;
    transform: rotate(-3deg);
    opacity: 0;
    width: 4%;
    max-width: 57px;

    @for $i from 1 through 9 {
      &:nth-of-type(#{$i}) {
        right: calc(4% * #{$i} - 3%);
        bottom: calc(80% + 1% * #{$i});
      }
    }
  }

  .txtLeft {
    @extend .txtRight;

    @for $i from 9 through 17 {
      &:nth-of-type(#{$i}) {
        left: calc(4% * #{$i} - 38%);
        top: calc(101% - 1% * #{$i});
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MainVisual.vue?010bd84e